import styled from "styled-components";
import { MainButtonContainer } from "../../components/main-button/main-button-style";

export const HomeContainer = styled.div`
  .notifications-container {
    margin-bottom: 50px;
    padding: 0 25px 0 15px;
  }

  .home-hero-intro-container {
    display: flex;
    gap: 40px;
    margin-bottom: 50px;
  }

  .home-hero-intro-item {
    background: #f9fbfc;
    padding: 20px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    &.pic {
      img {
        max-width: 800px;
        position: absolute;
        right: 0;
        z-index: -1;
        top: -10px;
      }
    }
  }

  .home-hero-intro-body {
    margin-bottom: 48px;
    font-family: "Museo Sans";
    font-weight: 700;
    font-size: 32px;
    color: #004f8b;
    line-height: 1.3em;
    max-width: 300px;

    p {
      color: #004f8b;
    }
  }

  .home-hero-intro-btn {
    max-width: 180px;
  }

  .home-stats {
    display: flex;
    flex-wrap: wrap;
    gap: 40px;
    padding: 20px;
    margin-bottom: 30px;
    background-color: #f9fbfc;
    border-bottom: 2px solid #ddd;
  }

  .home-hiring-data-container {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 20px;
    margin-right: 40px;
    border-radius: 3px;
    background: #f9fbfc;
  }

  .home-hiring-data-middle-container {
    display: flex;
    align-items: center;
    margin-bottom: 24px;
  }

  .home-hiring-data-amount {
    text-align: right;
    color: #6cc9f0;
    margin-right: 16px;

    p {
      color: #6cc9f0;
    }
  }

  .home-hiring-data-amount-hired {
    font-weight: 500;
    font-size: 100px;
  }

  .home-hiring-data-info {
    color: #004f8b;
    font-size: 18px;
    line-height: 22px;
  }

  .home-hiring-data-btn-container {
    max-width: 175px;
    ${MainButtonContainer} {
      max-height: 48px;
      .main-button-text {
        padding-top: 1px;
      }
    }
  }

  .pic {
    img {
      max-width: 600px;
      position: absolute;
      right: 50px;
      z-index: -1;
      top: 125px;
    }
  }
`;
